// finvise_reports_mock.js
// Mock data layer for the Finvise portal (Dashboard + Properties).
// Shape mirrors the future backend so it can be swapped for
// ../orgadmin/orgadmin_report (getManagementReports / getAllReportDetails)
// with no change to the components.
//
// Record fields: ref, type (RICS|AVM), address, postcode, region, lat, lng,
//   valuer, status (Submitted|In Progress|Cancelled), valuation,
//   feeEx, feeInc, tier, instructed (ISO), submitted (ISO|null),
//   rejectionReason (string|null), pvqResponseHours (number|null)

export const REJECTION_REASONS = [// 6 pre-defined + Other
    "Cancelled at client request",
    "Unsuitable for desktop valuation",
    "Insufficient digital information",
    "Physical inspection required",
    "Outside of scope",
    "Conflict of interest",
    "Other"];

export const CLIENT = { name: "Client", currency: "\u00a3" };

const DATA = [
{
"ref": "R012350",
"type": "RICS",
"address": "90 Grange Road, Sheffield",
"postcode": "S12 4AP",
"region": "Yorkshire and The Humber",
"lat": 53.4585,
"lng": -1.3886,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 116000,
"feeEx": 203.8,
"feeInc": 244.56,
"tier": "£100k–150k",
"instructed": "2026-08-05T18:35",
"submitted": "2026-08-06T18:30",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012888",
"type": "RICS",
"address": "81 Grange Road, Sunderland",
"postcode": "SR3 9HW",
"region": "North East",
"lat": 54.8637,
"lng": -1.279,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 125000,
"feeEx": 208.75,
"feeInc": 250.5,
"tier": "£100k–150k",
"instructed": "2026-08-05T05:53",
"submitted": "2026-08-06T18:30",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006729",
"type": "AVM",
"address": "46 Albion Terrace, Liverpool",
"postcode": "L1 5YZ",
"region": "North West",
"lat": 53.3373,
"lng": -2.8751,
"valuer": null,
"status": "Submitted",
"valuation": 307000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-08-01T19:53",
"submitted": "2026-08-04T23:53",
"rejectionReason": null,
"pvqResponseHours": 35.6
},
{
"ref": "R012341",
"type": "RICS",
"address": "74 Church Road, Manchester",
"postcode": "M1 2AL",
"region": "North West",
"lat": 53.4288,
"lng": -2.3261,
"valuer": "Marcus Adeyemi",
"status": "In Progress",
"valuation": 167000,
"feeEx": 231.85,
"feeInc": 278.22,
"tier": "£150k–200k",
"instructed": "2026-08-01T00:19",
"submitted": null,
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012524",
"type": "RICS",
"address": "66 Kings Road, Newcastle",
"postcode": "NE26 2TD",
"region": "North East",
"lat": 54.9133,
"lng": -1.505,
"valuer": "Daniel Lightstone",
"status": "In Progress",
"valuation": 364000,
"feeEx": 340.2,
"feeInc": 408.24,
"tier": "£350k–400k",
"instructed": "2026-07-30T19:04",
"submitted": null,
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012225",
"type": "RICS",
"address": "129 Albion Terrace, Manchester",
"postcode": "M6 3PJ",
"region": "North West",
"lat": 53.4523,
"lng": -2.1362,
"valuer": "Daniel Lightstone",
"status": "In Progress",
"valuation": 148000,
"feeEx": 221.4,
"feeInc": 265.68,
"tier": "£100k–150k",
"instructed": "2026-07-29T13:55",
"submitted": null,
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012832",
"type": "RICS",
"address": "99 Station Road, Bristol",
"postcode": "BS22 4QS",
"region": "South West",
"lat": 51.3766,
"lng": -2.5486,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 225000,
"feeEx": 263.75,
"feeInc": 316.5,
"tier": "£200k–250k",
"instructed": "2026-07-25T11:59",
"submitted": "2026-08-01T11:59",
"rejectionReason": null,
"pvqResponseHours": 12.3
},
{
"ref": "R012892",
"type": "RICS",
"address": "31 Clarence Street, Sheffield",
"postcode": "S22 9PL",
"region": "Yorkshire and The Humber",
"lat": 53.3278,
"lng": -1.4181,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 459000,
"feeEx": 392.45,
"feeInc": 470.94,
"tier": "£450k–500k",
"instructed": "2026-07-22T03:26",
"submitted": "2026-07-23T12:26",
"rejectionReason": null,
"pvqResponseHours": 15.2
},
{
"ref": "R012473",
"type": "RICS",
"address": "116 Albion Terrace, Leeds",
"postcode": "LS11 7PL",
"region": "Yorkshire and The Humber",
"lat": 53.7774,
"lng": -1.6324,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 267000,
"feeEx": 286.85,
"feeInc": 344.22,
"tier": "£250k–300k",
"instructed": "2026-07-21T08:15",
"submitted": "2026-07-28T14:15",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012497",
"type": "RICS",
"address": "40 Albion Terrace, Plymouth",
"postcode": "PL7 8TJ",
"region": "South West",
"lat": 50.439,
"lng": -4.2382,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 147000,
"feeEx": 220.85,
"feeInc": 265.02,
"tier": "£100k–150k",
"instructed": "2026-07-20T08:51",
"submitted": "2026-07-27T12:51",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012371",
"type": "RICS",
"address": "87 Church Road, Bristol",
"postcode": "BS27 3TB",
"region": "South West",
"lat": 51.438,
"lng": -2.5457,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 169000,
"feeEx": 232.95,
"feeInc": 279.54,
"tier": "£150k–200k",
"instructed": "2026-07-17T02:02",
"submitted": "2026-07-24T04:02",
"rejectionReason": null,
"pvqResponseHours": 16.8
},
{
"ref": "F006705",
"type": "AVM",
"address": "11 Clarence Street, Newcastle",
"postcode": "NE28 6NA",
"region": "North East",
"lat": 54.9261,
"lng": -1.6914,
"valuer": null,
"status": "Submitted",
"valuation": 458000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-07-16T01:48",
"submitted": "2026-07-20T08:48",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012316",
"type": "RICS",
"address": "100 Mill Lane, Plymouth",
"postcode": "PL12 4EY",
"region": "South West",
"lat": 50.4173,
"lng": -4.1822,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 305000,
"feeEx": 307.75,
"feeInc": 369.3,
"tier": "£300k–350k",
"instructed": "2026-07-15T23:17",
"submitted": "2026-07-20T23:17",
"rejectionReason": null,
"pvqResponseHours": 20.3
},
{
"ref": "R012432",
"type": "RICS",
"address": "102 Victoria Street, Coventry",
"postcode": "CV14 7SN",
"region": "West Midlands",
"lat": 52.3387,
"lng": -1.625,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 320000,
"feeEx": 316.0,
"feeInc": 379.2,
"tier": "£300k–350k",
"instructed": "2026-07-11T18:12",
"submitted": "2026-07-19T19:12",
"rejectionReason": null,
"pvqResponseHours": 29.1
},
{
"ref": "F006883",
"type": "AVM",
"address": "6 Clarence Street, Derby",
"postcode": "DE10 7SX",
"region": "East Midlands",
"lat": 52.9666,
"lng": -1.4649,
"valuer": null,
"status": "In Progress",
"valuation": 360000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-07-09T22:14",
"submitted": null,
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012424",
"type": "RICS",
"address": "112 Victoria Street, Coventry",
"postcode": "CV28 5PJ",
"region": "West Midlands",
"lat": 52.378,
"lng": -1.5896,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 329000,
"feeEx": 320.95,
"feeInc": 385.14,
"tier": "£300k–350k",
"instructed": "2026-07-05T11:13",
"submitted": "2026-07-12T19:13",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006773",
"type": "AVM",
"address": "87 Priory Lane, Swansea",
"postcode": "SA2 5HY",
"region": "Wales",
"lat": 51.606,
"lng": -3.9096,
"valuer": null,
"status": "Cancelled",
"valuation": 110000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-07-04T18:08",
"submitted": null,
"rejectionReason": "Unsuitable for Desktop Valuation",
"pvqResponseHours": null
},
{
"ref": "R012905",
"type": "RICS",
"address": "139 Church Road, Walthamstow",
"postcode": "E177 7BG",
"region": "London",
"lat": 51.5642,
"lng": 0.0975,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 128000,
"feeEx": 210.4,
"feeInc": 252.48,
"tier": "£100k–150k",
"instructed": "2026-07-02T09:19",
"submitted": "2026-07-05T15:19",
"rejectionReason": null,
"pvqResponseHours": 28.6
},
{
"ref": "R012783",
"type": "RICS",
"address": "110 Marlborough Road, Swansea",
"postcode": "SA15 5JL",
"region": "Wales",
"lat": 51.6688,
"lng": -3.9379,
"valuer": "Amelia Fothergill",
"status": "Cancelled",
"valuation": 342000,
"feeEx": 328.1,
"feeInc": 393.72,
"tier": "£300k–350k",
"instructed": "2026-06-30T09:37",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "R012542",
"type": "RICS",
"address": "6 Windsor Drive, Sunderland",
"postcode": "SR27 5JZ",
"region": "North East",
"lat": 54.9603,
"lng": -1.4504,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 225000,
"feeEx": 263.75,
"feeInc": 316.5,
"tier": "£200k–250k",
"instructed": "2026-06-30T04:58",
"submitted": "2026-07-01T13:58",
"rejectionReason": null,
"pvqResponseHours": 10.1
},
{
"ref": "F006709",
"type": "AVM",
"address": "9 Station Road, Leeds",
"postcode": "LS4 1TZ",
"region": "Yorkshire and The Humber",
"lat": 53.831,
"lng": -1.4597,
"valuer": null,
"status": "Submitted",
"valuation": 520000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-06-22T17:19",
"submitted": "2026-06-26T20:19",
"rejectionReason": null,
"pvqResponseHours": 3.0
},
{
"ref": "R012643",
"type": "RICS",
"address": "43 Church Road, Croydon",
"postcode": "CR23 7LW",
"region": "London",
"lat": 51.3792,
"lng": -0.1149,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 454000,
"feeEx": 389.7,
"feeInc": 467.64,
"tier": "£450k–500k",
"instructed": "2026-06-16T14:05",
"submitted": "2026-06-24T15:05",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012845",
"type": "RICS",
"address": "41 Highfield Road, Sheffield",
"postcode": "S12 5JJ",
"region": "Yorkshire and The Humber",
"lat": 53.2953,
"lng": -1.5436,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 300000,
"feeEx": 305.0,
"feeInc": 366.0,
"tier": "£300k–350k",
"instructed": "2026-06-14T16:11",
"submitted": "2026-06-22T19:11",
"rejectionReason": null,
"pvqResponseHours": 31.3
},
{
"ref": "R012569",
"type": "RICS",
"address": "121 Victoria Street, Manchester",
"postcode": "M21 2PX",
"region": "North West",
"lat": 53.4584,
"lng": -2.286,
"valuer": "Amelia Fothergill",
"status": "Cancelled",
"valuation": 269000,
"feeEx": 287.95,
"feeInc": 345.54,
"tier": "£250k–300k",
"instructed": "2026-06-12T13:04",
"submitted": null,
"rejectionReason": "Physical Inspection required",
"pvqResponseHours": null
},
{
"ref": "R012882",
"type": "RICS",
"address": "9 Surrey Street, Luton",
"postcode": "LU1 3BX",
"region": "East of England",
"lat": 51.877,
"lng": -0.417,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 320000,
"feeEx": 303.33,
"feeInc": 364.0,
"tier": "£300k–350k",
"instructed": "2026-06-11T12:00",
"submitted": "2026-06-13T12:00",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012854",
"type": "RICS",
"address": "124 Sefton Road, Stevenage",
"postcode": "SG1 5RN",
"region": "East of England",
"lat": 51.911,
"lng": -0.207,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 120000,
"feeEx": 191.67,
"feeInc": 230.0,
"tier": "£100k–150k",
"instructed": "2026-06-10T17:00",
"submitted": "2026-06-13T20:00",
"rejectionReason": null,
"pvqResponseHours": 4.9
},
{
"ref": "R012834",
"type": "RICS",
"address": "Flat 4 Datchet House, Hounslow",
"postcode": "TW4 6FB",
"region": "London",
"lat": 51.459,
"lng": -0.386,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 315000,
"feeEx": 303.33,
"feeInc": 364.0,
"tier": "£300k–350k",
"instructed": "2026-06-10T16:00",
"submitted": "2026-06-16T17:00",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006841",
"type": "AVM",
"address": "40 Foundry Court, Slough",
"postcode": "SL2 5FY",
"region": "South East",
"lat": 51.517,
"lng": -0.595,
"valuer": null,
"status": "In Progress",
"valuation": null,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-06-10T09:00",
"submitted": null,
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012792",
"type": "RICS",
"address": "49 Auburn Gardens, Newcastle",
"postcode": "NE4 9XQ",
"region": "North East",
"lat": 54.977,
"lng": -1.665,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 370000,
"feeEx": 338.33,
"feeInc": 406.0,
"tier": "£350k–400k",
"instructed": "2026-06-09T16:00",
"submitted": "2026-06-15T16:00",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012822",
"type": "RICS",
"address": "25 Harbury Close, Bolton",
"postcode": "BL3 4JY",
"region": "North West",
"lat": 53.567,
"lng": -2.443,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 220000,
"feeEx": 256.67,
"feeInc": 308.0,
"tier": "£200k–250k",
"instructed": "2026-06-09T14:00",
"submitted": "2026-06-11T14:00",
"rejectionReason": null,
"pvqResponseHours": 8.5
},
{
"ref": "R012752",
"type": "RICS",
"address": "10 Queen Elizabeth Ave, Walsall",
"postcode": "WS2 0HG",
"region": "West Midlands",
"lat": 52.593,
"lng": -2.012,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 165000,
"feeEx": 210.0,
"feeInc": 252.0,
"tier": "£150k–200k",
"instructed": "2026-06-08T11:00",
"submitted": "2026-06-14T17:00",
"rejectionReason": null,
"pvqResponseHours": 18.5
},
{
"ref": "R012238",
"type": "RICS",
"address": "106 Marlborough Road, Brighton",
"postcode": "BN15 8WQ",
"region": "South East",
"lat": 50.7601,
"lng": -0.073,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 451000,
"feeEx": 388.05,
"feeInc": 465.66,
"tier": "£450k–500k",
"instructed": "2026-06-08T01:03",
"submitted": "2026-06-11T06:03",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006894",
"type": "AVM",
"address": "137 Victoria Street, Brighton",
"postcode": "BN28 7HX",
"region": "South East",
"lat": 50.8729,
"lng": -0.1064,
"valuer": null,
"status": "Submitted",
"valuation": 368000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-06-06T19:57",
"submitted": "2026-06-09T23:57",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012733",
"type": "RICS",
"address": "4 Lauren Drive, Keighley",
"postcode": "BD22 7BR",
"region": "Yorkshire and The Humber",
"lat": 53.867,
"lng": -1.938,
"valuer": "Jack Kibblewhite",
"status": "Cancelled",
"valuation": 140000,
"feeEx": 191.67,
"feeInc": 230.0,
"tier": "£100k–150k",
"instructed": "2026-06-05T13:00",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "R012193",
"type": "RICS",
"address": "34 Clarence Street, Coventry",
"postcode": "CV9 8JF",
"region": "West Midlands",
"lat": 52.3354,
"lng": -1.5603,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 411000,
"feeEx": 366.05,
"feeInc": 439.26,
"tier": "£400k–450k",
"instructed": "2026-06-04T22:47",
"submitted": "2026-06-11T01:47",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012692",
"type": "RICS",
"address": "70 Welbury Road, Leicester",
"postcode": "LE5 1LX",
"region": "East Midlands",
"lat": 52.641,
"lng": -1.083,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 286000,
"feeEx": 268.33,
"feeInc": 322.0,
"tier": "£250k–300k",
"instructed": "2026-06-04T15:00",
"submitted": "2026-06-06T17:00",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012956",
"type": "RICS",
"address": "138 Station Road, Luton",
"postcode": "LU1 5WG",
"region": "East of England",
"lat": 51.8794,
"lng": -0.5145,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 261000,
"feeEx": 283.55,
"feeInc": 340.26,
"tier": "£250k–300k",
"instructed": "2026-06-01T09:16",
"submitted": "2026-06-06T15:16",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012699",
"type": "RICS",
"address": "63 Grange Road, Newcastle",
"postcode": "NE6 8HQ",
"region": "North East",
"lat": 55.0316,
"lng": -1.6553,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 526000,
"feeEx": 429.3,
"feeInc": 515.16,
"tier": "£500k–550k",
"instructed": "2026-06-01T05:45",
"submitted": "2026-06-07T05:45",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012444",
"type": "RICS",
"address": "24 Mill Lane, Manchester",
"postcode": "M10 6YZ",
"region": "North West",
"lat": 53.4053,
"lng": -2.3494,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 306000,
"feeEx": 308.3,
"feeInc": 369.96,
"tier": "£300k–350k",
"instructed": "2026-05-30T15:37",
"submitted": "2026-06-07T20:37",
"rejectionReason": null,
"pvqResponseHours": 22.8
},
{
"ref": "F006481",
"type": "AVM",
"address": "68 Fowlmere Road, Birmingham",
"postcode": "B42 2EA",
"region": "West Midlands",
"lat": 52.531,
"lng": -1.9,
"valuer": null,
"status": "In Progress",
"valuation": 210490,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-05-28T13:00",
"submitted": null,
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012979",
"type": "RICS",
"address": "137 Kings Road, Swansea",
"postcode": "SA8 6BJ",
"region": "Wales",
"lat": 51.6789,
"lng": -3.8698,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 346000,
"feeEx": 330.3,
"feeInc": 396.36,
"tier": "£300k–350k",
"instructed": "2026-05-24T11:12",
"submitted": "2026-05-29T21:12",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012286",
"type": "RICS",
"address": "22 Highfield Road, Bristol",
"postcode": "BS4 2PN",
"region": "South West",
"lat": 51.4192,
"lng": -2.5634,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 329000,
"feeEx": 320.95,
"feeInc": 385.14,
"tier": "£300k–350k",
"instructed": "2026-05-23T17:20",
"submitted": "2026-05-27T01:20",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012279",
"type": "RICS",
"address": "11 Grange Road, Coventry",
"postcode": "CV3 7QW",
"region": "West Midlands",
"lat": 52.4622,
"lng": -1.4669,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 289000,
"feeEx": 298.95,
"feeInc": 358.74,
"tier": "£250k–300k",
"instructed": "2026-05-23T15:00",
"submitted": "2026-05-30T19:00",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012173",
"type": "RICS",
"address": "36 Church Road, Norwich",
"postcode": "NR5 6ZP",
"region": "East of England",
"lat": 52.5693,
"lng": 1.4147,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 368000,
"feeEx": 342.4,
"feeInc": 410.88,
"tier": "£350k–400k",
"instructed": "2026-05-18T19:27",
"submitted": "2026-05-26T21:27",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012602",
"type": "RICS",
"address": "62 Priory Lane, Luton",
"postcode": "LU15 2FU",
"region": "East of England",
"lat": 51.9559,
"lng": -0.47,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 410000,
"feeEx": 365.5,
"feeInc": 438.6,
"tier": "£400k–450k",
"instructed": "2026-05-17T10:10",
"submitted": "2026-05-24T11:10",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012714",
"type": "RICS",
"address": "118 Meadow View, Derby",
"postcode": "DE25 8TS",
"region": "East Midlands",
"lat": 52.9806,
"lng": -1.4538,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 183000,
"feeEx": 240.65,
"feeInc": 288.78,
"tier": "£150k–200k",
"instructed": "2026-05-16T12:33",
"submitted": "2026-05-21T21:33",
"rejectionReason": null,
"pvqResponseHours": 10.0
},
{
"ref": "R012983",
"type": "RICS",
"address": "50 Meadow View, Swansea",
"postcode": "SA9 8QG",
"region": "Wales",
"lat": 51.5976,
"lng": -4.0127,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 214000,
"feeEx": 257.7,
"feeInc": 309.24,
"tier": "£200k–250k",
"instructed": "2026-05-15T12:38",
"submitted": "2026-05-17T15:38",
"rejectionReason": null,
"pvqResponseHours": 33.8
},
{
"ref": "R012420",
"type": "RICS",
"address": "115 York Street, Cardiff",
"postcode": "CF5 8DU",
"region": "Wales",
"lat": 51.4706,
"lng": -3.2263,
"valuer": "Daniel Lightstone",
"status": "Cancelled",
"valuation": 459000,
"feeEx": 392.45,
"feeInc": 470.94,
"tier": "£450k–500k",
"instructed": "2026-05-06T23:50",
"submitted": null,
"rejectionReason": "Insufficient digital information available",
"pvqResponseHours": null
},
{
"ref": "R012931",
"type": "RICS",
"address": "72 Orchard Close, Bristol",
"postcode": "BS26 7HE",
"region": "South West",
"lat": 51.3814,
"lng": -2.6045,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 412000,
"feeEx": 366.6,
"feeInc": 439.92,
"tier": "£400k–450k",
"instructed": "2026-05-02T13:37",
"submitted": "2026-05-10T16:37",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012850",
"type": "RICS",
"address": "64 Elm Grove, Coventry",
"postcode": "CV14 1GP",
"region": "West Midlands",
"lat": 52.4588,
"lng": -1.5312,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 416000,
"feeEx": 368.8,
"feeInc": 442.56,
"tier": "£400k–450k",
"instructed": "2026-05-01T19:45",
"submitted": "2026-05-04T22:45",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012821",
"type": "RICS",
"address": "80 Marlborough Road, Sunderland",
"postcode": "SR22 3ZY",
"region": "North East",
"lat": 54.8702,
"lng": -1.3715,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 304000,
"feeEx": 307.2,
"feeInc": 368.64,
"tier": "£300k–350k",
"instructed": "2026-05-01T19:23",
"submitted": "2026-05-04T22:23",
"rejectionReason": null,
"pvqResponseHours": 11.4
},
{
"ref": "R012153",
"type": "RICS",
"address": "68 Beech Avenue, Swansea",
"postcode": "SA6 9ZR",
"region": "Wales",
"lat": 51.5576,
"lng": -3.8996,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 459000,
"feeEx": 392.45,
"feeInc": 470.94,
"tier": "£450k–500k",
"instructed": "2026-04-27T16:38",
"submitted": "2026-05-01T16:38",
"rejectionReason": null,
"pvqResponseHours": 34.2
},
{
"ref": "F006900",
"type": "AVM",
"address": "55 Chestnut Walk, Cardiff",
"postcode": "CF24 9XL",
"region": "Wales",
"lat": 51.5255,
"lng": -3.1962,
"valuer": null,
"status": "Submitted",
"valuation": 342000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-04-27T15:18",
"submitted": "2026-05-02T17:18",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012099",
"type": "RICS",
"address": "67 Mill Lane, Cardiff",
"postcode": "CF13 9NE",
"region": "Wales",
"lat": 51.506,
"lng": -3.0732,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 210000,
"feeEx": 255.5,
"feeInc": 306.6,
"tier": "£200k–250k",
"instructed": "2026-04-26T23:58",
"submitted": "2026-04-29T06:58",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012502",
"type": "RICS",
"address": "57 Priory Lane, Birmingham",
"postcode": "B2 5UE",
"region": "West Midlands",
"lat": 52.4135,
"lng": -1.7971,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 344000,
"feeEx": 329.2,
"feeInc": 395.04,
"tier": "£300k–350k",
"instructed": "2026-04-24T19:16",
"submitted": "2026-05-01T20:16",
"rejectionReason": null,
"pvqResponseHours": 17.2
},
{
"ref": "F006826",
"type": "AVM",
"address": "118 Windsor Drive, Bristol",
"postcode": "BS14 2UT",
"region": "South West",
"lat": 51.3772,
"lng": -2.6886,
"valuer": null,
"status": "Cancelled",
"valuation": 117000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-04-23T05:35",
"submitted": null,
"rejectionReason": "Unsuitable for Desktop Valuation",
"pvqResponseHours": null
},
{
"ref": "R012354",
"type": "RICS",
"address": "14 Highfield Road, Manchester",
"postcode": "M3 3LT",
"region": "North West",
"lat": 53.553,
"lng": -2.3266,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 288000,
"feeEx": 298.4,
"feeInc": 358.08,
"tier": "£250k–300k",
"instructed": "2026-04-22T10:42",
"submitted": "2026-04-24T18:42",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012220",
"type": "RICS",
"address": "51 Highfield Road, Croydon",
"postcode": "CR20 9DW",
"region": "London",
"lat": 51.3974,
"lng": -0.078,
"valuer": "Daniel Lightstone",
"status": "Cancelled",
"valuation": 227000,
"feeEx": 264.85,
"feeInc": 317.82,
"tier": "£200k–250k",
"instructed": "2026-04-20T05:12",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "R012308",
"type": "RICS",
"address": "123 Grange Road, Liverpool",
"postcode": "L2 4BP",
"region": "North West",
"lat": 53.486,
"lng": -2.9873,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 161000,
"feeEx": 228.55,
"feeInc": 274.26,
"tier": "£150k–200k",
"instructed": "2026-04-19T00:11",
"submitted": "2026-04-27T00:11",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012449",
"type": "RICS",
"address": "7 Priory Lane, Plymouth",
"postcode": "PL23 5PQ",
"region": "South West",
"lat": 50.2861,
"lng": -4.0532,
"valuer": "Daniel Lightstone",
"status": "Cancelled",
"valuation": 225000,
"feeEx": 263.75,
"feeInc": 316.5,
"tier": "£200k–250k",
"instructed": "2026-04-10T17:28",
"submitted": null,
"rejectionReason": "Insufficient digital information available",
"pvqResponseHours": null
},
{
"ref": "R012183",
"type": "RICS",
"address": "84 Kings Road, Sheffield",
"postcode": "S10 8AD",
"region": "Yorkshire and The Humber",
"lat": 53.4611,
"lng": -1.4687,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 192000,
"feeEx": 245.6,
"feeInc": 294.72,
"tier": "£150k–200k",
"instructed": "2026-03-30T07:54",
"submitted": "2026-04-07T15:54",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012038",
"type": "RICS",
"address": "15 Grange Road, Manchester",
"postcode": "M7 6DT",
"region": "North West",
"lat": 53.5425,
"lng": -2.3398,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 328000,
"feeEx": 320.4,
"feeInc": 384.48,
"tier": "£300k–350k",
"instructed": "2026-03-24T18:12",
"submitted": "2026-03-28T00:12",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012862",
"type": "RICS",
"address": "110 Cedar Close, Reading",
"postcode": "RG5 7FB",
"region": "South East",
"lat": 51.4195,
"lng": -0.8822,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 127000,
"feeEx": 209.85,
"feeInc": 251.82,
"tier": "£100k–150k",
"instructed": "2026-03-24T05:16",
"submitted": "2026-03-25T10:16",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012589",
"type": "RICS",
"address": "115 Park Avenue, Brighton",
"postcode": "BN23 4YR",
"region": "South East",
"lat": 50.779,
"lng": -0.0859,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 268000,
"feeEx": 287.4,
"feeInc": 344.88,
"tier": "£250k–300k",
"instructed": "2026-03-16T02:11",
"submitted": "2026-03-23T09:11",
"rejectionReason": null,
"pvqResponseHours": 27.2
},
{
"ref": "R012065",
"type": "RICS",
"address": "46 Station Road, Coventry",
"postcode": "CV22 9SX",
"region": "West Midlands",
"lat": 52.3863,
"lng": -1.5749,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 163000,
"feeEx": 229.65,
"feeInc": 275.58,
"tier": "£150k–200k",
"instructed": "2026-03-15T14:38",
"submitted": "2026-03-16T14:38",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012161",
"type": "RICS",
"address": "131 Marlborough Road, Birmingham",
"postcode": "B22 2SY",
"region": "West Midlands",
"lat": 52.4514,
"lng": -1.7943,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 454000,
"feeEx": 389.7,
"feeInc": 467.64,
"tier": "£450k–500k",
"instructed": "2026-03-13T19:39",
"submitted": "2026-03-21T19:39",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012689",
"type": "RICS",
"address": "3 Cedar Close, Newcastle",
"postcode": "NE16 9JU",
"region": "North East",
"lat": 55.0043,
"lng": -1.6192,
"valuer": "Amelia Fothergill",
"status": "Cancelled",
"valuation": 128000,
"feeEx": 210.4,
"feeInc": 252.48,
"tier": "£100k–150k",
"instructed": "2026-03-08T02:21",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "R012379",
"type": "RICS",
"address": "109 Victoria Street, Bristol",
"postcode": "BS7 4FF",
"region": "South West",
"lat": 51.3779,
"lng": -2.5053,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 284000,
"feeEx": 296.2,
"feeInc": 355.44,
"tier": "£250k–300k",
"instructed": "2026-03-05T03:14",
"submitted": "2026-03-08T06:14",
"rejectionReason": null,
"pvqResponseHours": 28.1
},
{
"ref": "R012581",
"type": "RICS",
"address": "39 Clarence Street, Nottingham",
"postcode": "NG28 2TE",
"region": "East Midlands",
"lat": 52.9587,
"lng": -1.1683,
"valuer": "Daniel Lightstone",
"status": "Cancelled",
"valuation": 168000,
"feeEx": 232.4,
"feeInc": 278.88,
"tier": "£150k–200k",
"instructed": "2026-02-28T08:14",
"submitted": null,
"rejectionReason": "Unsuitable for Desktop Valuation",
"pvqResponseHours": null
},
{
"ref": "R012439",
"type": "RICS",
"address": "109 Grange Road, Newcastle",
"postcode": "NE14 2NY",
"region": "North East",
"lat": 54.9756,
"lng": -1.5769,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 324000,
"feeEx": 318.2,
"feeInc": 381.84,
"tier": "£300k–350k",
"instructed": "2026-02-24T19:46",
"submitted": "2026-03-01T03:46",
"rejectionReason": null,
"pvqResponseHours": 15.1
},
{
"ref": "R012112",
"type": "RICS",
"address": "130 Park Avenue, Brighton",
"postcode": "BN23 3AP",
"region": "South East",
"lat": 50.8793,
"lng": -0.1357,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 145000,
"feeEx": 219.75,
"feeInc": 263.7,
"tier": "£100k–150k",
"instructed": "2026-02-18T09:37",
"submitted": "2026-02-21T16:37",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006875",
"type": "AVM",
"address": "56 York Street, Walthamstow",
"postcode": "E174 1NY",
"region": "London",
"lat": 51.6179,
"lng": 0.091,
"valuer": null,
"status": "Submitted",
"valuation": 282000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-02-17T07:31",
"submitted": "2026-02-19T09:31",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012812",
"type": "RICS",
"address": "83 Priory Lane, Cardiff",
"postcode": "CF10 9ZP",
"region": "Wales",
"lat": 51.4078,
"lng": -3.0705,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 198000,
"feeEx": 248.9,
"feeInc": 298.68,
"tier": "£150k–200k",
"instructed": "2026-02-17T07:07",
"submitted": "2026-02-25T09:07",
"rejectionReason": null,
"pvqResponseHours": 12.2
},
{
"ref": "R012617",
"type": "RICS",
"address": "139 Mill Lane, Bristol",
"postcode": "BS21 8BH",
"region": "South West",
"lat": 51.4121,
"lng": -2.6766,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 198000,
"feeEx": 248.9,
"feeInc": 298.68,
"tier": "£150k–200k",
"instructed": "2026-02-16T04:48",
"submitted": "2026-02-22T13:48",
"rejectionReason": null,
"pvqResponseHours": 31.9
},
{
"ref": "F006789",
"type": "AVM",
"address": "80 Victoria Street, Bristol",
"postcode": "BS28 2ZZ",
"region": "South West",
"lat": 51.4553,
"lng": -2.5969,
"valuer": null,
"status": "Submitted",
"valuation": 115000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-02-16T02:46",
"submitted": "2026-02-21T03:46",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006718",
"type": "AVM",
"address": "107 Marlborough Road, Manchester",
"postcode": "M9 1HY",
"region": "North West",
"lat": 53.4031,
"lng": -2.2603,
"valuer": null,
"status": "Submitted",
"valuation": 417000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-02-14T07:33",
"submitted": "2026-02-19T07:33",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012596",
"type": "RICS",
"address": "63 Beech Avenue, Brighton",
"postcode": "BN11 9LA",
"region": "South East",
"lat": 50.7879,
"lng": -0.2003,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 303000,
"feeEx": 306.65,
"feeInc": 367.98,
"tier": "£300k–350k",
"instructed": "2026-02-14T07:27",
"submitted": "2026-02-17T08:27",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012092",
"type": "RICS",
"address": "40 Beech Avenue, Manchester",
"postcode": "M26 4JZ",
"region": "North West",
"lat": 53.5472,
"lng": -2.3424,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 525000,
"feeEx": 428.75,
"feeInc": 514.5,
"tier": "£500k–550k",
"instructed": "2026-02-13T15:39",
"submitted": "2026-02-20T23:39",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012943",
"type": "RICS",
"address": "133 Grange Road, Coventry",
"postcode": "CV8 4AD",
"region": "West Midlands",
"lat": 52.4454,
"lng": -1.6159,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 211000,
"feeEx": 256.05,
"feeInc": 307.26,
"tier": "£200k–250k",
"instructed": "2026-02-12T09:08",
"submitted": "2026-02-18T09:08",
"rejectionReason": null,
"pvqResponseHours": 2.6
},
{
"ref": "R012876",
"type": "RICS",
"address": "41 Windsor Drive, Coventry",
"postcode": "CV22 2FL",
"region": "West Midlands",
"lat": 52.3388,
"lng": -1.6043,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 249000,
"feeEx": 276.95,
"feeInc": 332.34,
"tier": "£200k–250k",
"instructed": "2026-02-07T12:54",
"submitted": "2026-02-08T22:54",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006756",
"type": "AVM",
"address": "81 Grange Road, Luton",
"postcode": "LU5 9HX",
"region": "East of England",
"lat": 51.8465,
"lng": -0.3811,
"valuer": null,
"status": "Submitted",
"valuation": 196000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-01-31T11:21",
"submitted": "2026-02-08T11:21",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012120",
"type": "RICS",
"address": "41 Mill Lane, Manchester",
"postcode": "M21 1DY",
"region": "North West",
"lat": 53.4318,
"lng": -2.1847,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 367000,
"feeEx": 341.85,
"feeInc": 410.22,
"tier": "£350k–400k",
"instructed": "2026-01-27T03:36",
"submitted": "2026-01-31T07:36",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012916",
"type": "RICS",
"address": "16 Station Road, Norwich",
"postcode": "NR5 7GL",
"region": "East of England",
"lat": 52.6233,
"lng": 1.3869,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 143000,
"feeEx": 218.65,
"feeInc": 262.38,
"tier": "£100k–150k",
"instructed": "2026-01-25T14:09",
"submitted": "2026-01-29T17:09",
"rejectionReason": null,
"pvqResponseHours": 29.4
},
{
"ref": "R012839",
"type": "RICS",
"address": "131 Meadow View, Newcastle",
"postcode": "NE19 5BE",
"region": "North East",
"lat": 54.9954,
"lng": -1.654,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 415000,
"feeEx": 368.25,
"feeInc": 441.9,
"tier": "£400k–450k",
"instructed": "2026-01-24T12:26",
"submitted": "2026-01-25T13:26",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012032",
"type": "RICS",
"address": "53 Orchard Close, Brighton",
"postcode": "BN13 8XQ",
"region": "South East",
"lat": 50.7925,
"lng": -0.1857,
"valuer": "Daniel Lightstone",
"status": "Cancelled",
"valuation": 415000,
"feeEx": 368.25,
"feeInc": 441.9,
"tier": "£400k–450k",
"instructed": "2026-01-23T09:49",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "F006760",
"type": "AVM",
"address": "19 Windsor Drive, Plymouth",
"postcode": "PL13 6PX",
"region": "South West",
"lat": 50.454,
"lng": -4.0808,
"valuer": null,
"status": "Submitted",
"valuation": 414000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-01-19T15:58",
"submitted": "2026-01-21T17:58",
"rejectionReason": null,
"pvqResponseHours": 19.1
},
{
"ref": "F006817",
"type": "AVM",
"address": "84 Priory Lane, Newcastle",
"postcode": "NE17 7EE",
"region": "North East",
"lat": 55.0415,
"lng": -1.5808,
"valuer": null,
"status": "Cancelled",
"valuation": 384000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-01-17T16:23",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "R012408",
"type": "RICS",
"address": "94 Kings Road, Swansea",
"postcode": "SA22 1PD",
"region": "Wales",
"lat": 51.5903,
"lng": -3.9291,
"valuer": "Daniel Lightstone",
"status": "Cancelled",
"valuation": 306000,
"feeEx": 308.3,
"feeInc": 369.96,
"tier": "£300k–350k",
"instructed": "2026-01-14T18:01",
"submitted": null,
"rejectionReason": "Unsuitable for Desktop Valuation",
"pvqResponseHours": null
},
{
"ref": "R012459",
"type": "RICS",
"address": "80 Windsor Drive, Norwich",
"postcode": "NR28 2QX",
"region": "East of England",
"lat": 52.6062,
"lng": 1.36,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 383000,
"feeEx": 350.65,
"feeInc": 420.78,
"tier": "£350k–400k",
"instructed": "2026-01-07T00:43",
"submitted": "2026-01-10T10:43",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006796",
"type": "AVM",
"address": "90 Elm Grove, Bristol",
"postcode": "BS7 3ZF",
"region": "South West",
"lat": 51.5008,
"lng": -2.5507,
"valuer": null,
"status": "Submitted",
"valuation": 163000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2026-01-06T19:57",
"submitted": "2026-01-08T21:57",
"rejectionReason": null,
"pvqResponseHours": 28.2
},
{
"ref": "R012626",
"type": "RICS",
"address": "121 Victoria Street, Brighton",
"postcode": "BN10 7XB",
"region": "South East",
"lat": 50.8189,
"lng": -0.1965,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 261000,
"feeEx": 283.55,
"feeInc": 340.26,
"tier": "£250k–300k",
"instructed": "2026-01-05T16:31",
"submitted": "2026-01-08T21:31",
"rejectionReason": null,
"pvqResponseHours": 35.0
},
{
"ref": "R012141",
"type": "RICS",
"address": "137 Grange Road, Liverpool",
"postcode": "L18 5JN",
"region": "North West",
"lat": 53.4568,
"lng": -2.9418,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 234000,
"feeEx": 268.7,
"feeInc": 322.44,
"tier": "£200k–250k",
"instructed": "2026-01-03T15:17",
"submitted": "2026-01-11T18:17",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012488",
"type": "RICS",
"address": "60 Elm Grove, Cardiff",
"postcode": "CF9 3EA",
"region": "Wales",
"lat": 51.4147,
"lng": -3.213,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 520000,
"feeEx": 426.0,
"feeInc": 511.2,
"tier": "£500k–550k",
"instructed": "2025-12-29T14:59",
"submitted": "2026-01-03T16:59",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006726",
"type": "AVM",
"address": "132 Albion Terrace, Nottingham",
"postcode": "NG8 1LR",
"region": "East Midlands",
"lat": 52.9064,
"lng": -1.0971,
"valuer": null,
"status": "Submitted",
"valuation": 142000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-12-29T09:28",
"submitted": "2026-01-01T16:28",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012412",
"type": "RICS",
"address": "49 Grange Road, Norwich",
"postcode": "NR23 2WG",
"region": "East of England",
"lat": 52.547,
"lng": 1.3468,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 382000,
"feeEx": 350.1,
"feeInc": 420.12,
"tier": "£350k–400k",
"instructed": "2025-12-27T01:32",
"submitted": "2025-12-28T08:32",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012528",
"type": "RICS",
"address": "11 Station Road, Manchester",
"postcode": "M11 7GH",
"region": "North West",
"lat": 53.4138,
"lng": -2.2325,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 119000,
"feeEx": 205.45,
"feeInc": 246.54,
"tier": "£100k–150k",
"instructed": "2025-12-22T11:29",
"submitted": "2025-12-28T13:29",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006868",
"type": "AVM",
"address": "63 Clarence Street, Sheffield",
"postcode": "S18 6QT",
"region": "Yorkshire and The Humber",
"lat": 53.3398,
"lng": -1.5297,
"valuer": null,
"status": "Submitted",
"valuation": 287000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-12-21T11:40",
"submitted": "2025-12-27T17:40",
"rejectionReason": null,
"pvqResponseHours": 8.1
},
{
"ref": "R012671",
"type": "RICS",
"address": "110 Windsor Drive, Reading",
"postcode": "RG9 2GJ",
"region": "South East",
"lat": 51.3953,
"lng": -1.08,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 119000,
"feeEx": 205.45,
"feeInc": 246.54,
"tier": "£100k–150k",
"instructed": "2025-12-21T04:27",
"submitted": "2025-12-23T07:27",
"rejectionReason": null,
"pvqResponseHours": 17.0
},
{
"ref": "R012325",
"type": "RICS",
"address": "37 Orchard Close, Cardiff",
"postcode": "CF22 2WQ",
"region": "Wales",
"lat": 51.4032,
"lng": -3.1727,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 525000,
"feeEx": 428.75,
"feeInc": 514.5,
"tier": "£500k–550k",
"instructed": "2025-12-16T01:10",
"submitted": "2025-12-20T10:10",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012658",
"type": "RICS",
"address": "60 Church Road, Sunderland",
"postcode": "SR22 4SE",
"region": "North East",
"lat": 54.914,
"lng": -1.3476,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 341000,
"feeEx": 327.55,
"feeInc": 393.06,
"tier": "£300k–350k",
"instructed": "2025-12-14T21:29",
"submitted": "2025-12-19T01:29",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012135",
"type": "RICS",
"address": "71 Meadow View, Brighton",
"postcode": "BN10 1ND",
"region": "South East",
"lat": 50.7993,
"lng": -0.1658,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 416000,
"feeEx": 368.8,
"feeInc": 442.56,
"tier": "£400k–450k",
"instructed": "2025-12-14T18:44",
"submitted": "2025-12-21T23:44",
"rejectionReason": null,
"pvqResponseHours": 18.0
},
{
"ref": "R012301",
"type": "RICS",
"address": "49 Church Road, Newcastle",
"postcode": "NE14 7TR",
"region": "North East",
"lat": 54.949,
"lng": -1.6922,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 115000,
"feeEx": 203.25,
"feeInc": 243.9,
"tier": "£100k–150k",
"instructed": "2025-12-14T04:04",
"submitted": "2025-12-19T05:04",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006769",
"type": "AVM",
"address": "13 Church Road, Coventry",
"postcode": "CV5 5QR",
"region": "West Midlands",
"lat": 52.3839,
"lng": -1.5339,
"valuer": null,
"status": "Submitted",
"valuation": 364000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-12-12T10:31",
"submitted": "2025-12-13T11:31",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012494",
"type": "RICS",
"address": "102 Church Road, Coventry",
"postcode": "CV1 1PJ",
"region": "West Midlands",
"lat": 52.496,
"lng": -1.4411,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 147000,
"feeEx": 220.85,
"feeInc": 265.02,
"tier": "£100k–150k",
"instructed": "2025-12-10T10:41",
"submitted": "2025-12-12T20:41",
"rejectionReason": null,
"pvqResponseHours": 30.1
},
{
"ref": "R012763",
"type": "RICS",
"address": "57 Beech Avenue, Sheffield",
"postcode": "S24 3TF",
"region": "Yorkshire and The Humber",
"lat": 53.4675,
"lng": -1.4618,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 101000,
"feeEx": 195.55,
"feeInc": 234.66,
"tier": "£100k–150k",
"instructed": "2025-12-09T08:56",
"submitted": "2025-12-15T18:56",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012769",
"type": "RICS",
"address": "61 Windsor Drive, Croydon",
"postcode": "CR23 3HD",
"region": "London",
"lat": 51.3567,
"lng": -0.1406,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 411000,
"feeEx": 366.05,
"feeInc": 439.26,
"tier": "£400k–450k",
"instructed": "2025-12-08T22:16",
"submitted": "2025-12-12T00:16",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012266",
"type": "RICS",
"address": "72 Chestnut Walk, Nottingham",
"postcode": "NG13 9EL",
"region": "East Midlands",
"lat": 53.0035,
"lng": -1.109,
"valuer": "Marcus Adeyemi",
"status": "Cancelled",
"valuation": 97000,
"feeEx": 193.35,
"feeInc": 232.02,
"tier": "£50k–100k",
"instructed": "2025-11-30T21:08",
"submitted": null,
"rejectionReason": "Outside of Scope",
"pvqResponseHours": null
},
{
"ref": "R012207",
"type": "RICS",
"address": "124 Windsor Drive, Sunderland",
"postcode": "SR6 8SU",
"region": "North East",
"lat": 54.8996,
"lng": -1.4214,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 304000,
"feeEx": 307.2,
"feeInc": 368.64,
"tier": "£300k–350k",
"instructed": "2025-11-29T03:46",
"submitted": "2025-12-07T04:46",
"rejectionReason": null,
"pvqResponseHours": 31.2
},
{
"ref": "R012799",
"type": "RICS",
"address": "12 Mill Lane, Manchester",
"postcode": "M21 4RU",
"region": "North West",
"lat": 53.4619,
"lng": -2.3266,
"valuer": "Amelia Fothergill",
"status": "Cancelled",
"valuation": 521000,
"feeEx": 426.55,
"feeInc": 511.86,
"tier": "£500k–550k",
"instructed": "2025-11-29T03:28",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "R012366",
"type": "RICS",
"address": "137 Orchard Close, Reading",
"postcode": "RG15 5RW",
"region": "South East",
"lat": 51.4589,
"lng": -0.8661,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 363000,
"feeEx": 339.65,
"feeInc": 407.58,
"tier": "£350k–400k",
"instructed": "2025-11-27T01:53",
"submitted": "2025-12-03T11:53",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012555",
"type": "RICS",
"address": "18 Church Road, Plymouth",
"postcode": "PL15 3NA",
"region": "South West",
"lat": 50.2933,
"lng": -4.0709,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 243000,
"feeEx": 273.65,
"feeInc": 328.38,
"tier": "£200k–250k",
"instructed": "2025-11-25T11:27",
"submitted": "2025-11-27T17:27",
"rejectionReason": null,
"pvqResponseHours": 14.4
},
{
"ref": "R012241",
"type": "RICS",
"address": "131 Meadow View, Liverpool",
"postcode": "L18 6TX",
"region": "North West",
"lat": 53.3414,
"lng": -2.8988,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 192000,
"feeEx": 245.6,
"feeInc": 294.72,
"tier": "£150k–200k",
"instructed": "2025-11-21T15:27",
"submitted": "2025-11-25T22:27",
"rejectionReason": null,
"pvqResponseHours": 15.2
},
{
"ref": "F006854",
"type": "AVM",
"address": "50 Kings Road, Plymouth",
"postcode": "PL10 4QG",
"region": "South West",
"lat": 50.3394,
"lng": -4.0921,
"valuer": null,
"status": "Submitted",
"valuation": 234000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-11-18T18:47",
"submitted": "2025-11-23T19:47",
"rejectionReason": null,
"pvqResponseHours": 3.1
},
{
"ref": "R012435",
"type": "RICS",
"address": "78 Elm Grove, Luton",
"postcode": "LU24 7GF",
"region": "East of England",
"lat": 51.8564,
"lng": -0.3711,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 229000,
"feeEx": 265.95,
"feeInc": 319.14,
"tier": "£200k–250k",
"instructed": "2025-11-16T21:47",
"submitted": "2025-11-22T22:47",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012865",
"type": "RICS",
"address": "88 Elm Grove, Swansea",
"postcode": "SA21 7LB",
"region": "Wales",
"lat": 51.5316,
"lng": -3.8779,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 233000,
"feeEx": 268.15,
"feeInc": 321.78,
"tier": "£200k–250k",
"instructed": "2025-11-14T03:03",
"submitted": "2025-11-22T07:03",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012789",
"type": "RICS",
"address": "57 Albion Terrace, Walthamstow",
"postcode": "E1715 3TW",
"region": "London",
"lat": 51.6738,
"lng": 0.0039,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 387000,
"feeEx": 352.85,
"feeInc": 423.42,
"tier": "£350k–400k",
"instructed": "2025-11-04T00:55",
"submitted": "2025-11-05T08:55",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006838",
"type": "AVM",
"address": "47 Albion Terrace, Bristol",
"postcode": "BS5 4TL",
"region": "South West",
"lat": 51.4467,
"lng": -2.548,
"valuer": null,
"status": "Submitted",
"valuation": 526000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-11-01T21:20",
"submitted": "2025-11-06T04:20",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012895",
"type": "RICS",
"address": "125 Cedar Close, Derby",
"postcode": "DE19 8WW",
"region": "East Midlands",
"lat": 52.8603,
"lng": -1.3654,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 190000,
"feeEx": 244.5,
"feeInc": 293.4,
"tier": "£150k–200k",
"instructed": "2025-10-27T08:38",
"submitted": "2025-10-28T13:38",
"rejectionReason": null,
"pvqResponseHours": 7.9
},
{
"ref": "R012951",
"type": "RICS",
"address": "51 Priory Lane, Bristol",
"postcode": "BS1 2QN",
"region": "South West",
"lat": 51.4071,
"lng": -2.6502,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 183000,
"feeEx": 240.65,
"feeInc": 288.78,
"tier": "£150k–200k",
"instructed": "2025-10-26T15:31",
"submitted": "2025-10-28T00:31",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012675",
"type": "RICS",
"address": "14 York Street, Croydon",
"postcode": "CR25 7ZZ",
"region": "London",
"lat": 51.4243,
"lng": -0.1658,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 454000,
"feeEx": 389.7,
"feeInc": 467.64,
"tier": "£450k–500k",
"instructed": "2025-10-26T05:48",
"submitted": "2025-10-28T08:48",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012058",
"type": "RICS",
"address": "15 Elm Grove, Plymouth",
"postcode": "PL8 5FW",
"region": "South West",
"lat": 50.3248,
"lng": -4.1899,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 243000,
"feeEx": 273.65,
"feeInc": 328.38,
"tier": "£200k–250k",
"instructed": "2025-10-22T00:31",
"submitted": "2025-10-28T09:31",
"rejectionReason": null,
"pvqResponseHours": 34.2
},
{
"ref": "F006742",
"type": "AVM",
"address": "70 Highfield Road, Plymouth",
"postcode": "PL17 4JB",
"region": "South West",
"lat": 50.303,
"lng": -4.1827,
"valuer": null,
"status": "Submitted",
"valuation": 453000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-10-20T23:30",
"submitted": "2025-10-24T23:30",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012256",
"type": "RICS",
"address": "32 Elm Grove, Brighton",
"postcode": "BN22 6DX",
"region": "South East",
"lat": 50.8346,
"lng": -0.0581,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 342000,
"feeEx": 328.1,
"feeInc": 393.72,
"tier": "£300k–350k",
"instructed": "2025-10-20T10:00",
"submitted": "2025-10-28T11:00",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012750",
"type": "RICS",
"address": "110 Victoria Street, Luton",
"postcode": "LU15 6PR",
"region": "East of England",
"lat": 51.8381,
"lng": -0.3117,
"valuer": "Nilufer Serbest",
"status": "Submitted",
"valuation": 175000,
"feeEx": 236.25,
"feeInc": 283.5,
"tier": "£150k–200k",
"instructed": "2025-10-20T09:45",
"submitted": "2025-10-25T15:45",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006776",
"type": "AVM",
"address": "9 Grange Road, Swansea",
"postcode": "SA20 3TQ",
"region": "Wales",
"lat": 51.598,
"lng": -3.8799,
"valuer": null,
"status": "Submitted",
"valuation": 285000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-10-16T23:00",
"submitted": "2025-10-24T08:00",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012331",
"type": "RICS",
"address": "109 Marlborough Road, Swansea",
"postcode": "SA21 8DE",
"region": "Wales",
"lat": 51.6816,
"lng": -3.943,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 214000,
"feeEx": 257.7,
"feeInc": 309.24,
"tier": "£200k–250k",
"instructed": "2025-10-11T11:33",
"submitted": "2025-10-13T11:33",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "F006848",
"type": "AVM",
"address": "126 Park Avenue, Sunderland",
"postcode": "SR11 3BL",
"region": "North East",
"lat": 54.9854,
"lng": -1.3883,
"valuer": null,
"status": "Submitted",
"valuation": 454000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-10-08T08:25",
"submitted": "2025-10-16T15:25",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012990",
"type": "RICS",
"address": "87 Elm Grove, Manchester",
"postcode": "M24 8XE",
"region": "North West",
"lat": 53.5652,
"lng": -2.2712,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 145000,
"feeEx": 219.75,
"feeInc": 263.7,
"tier": "£100k–150k",
"instructed": "2025-10-08T05:07",
"submitted": "2025-10-14T14:07",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012729",
"type": "RICS",
"address": "63 York Street, Croydon",
"postcode": "CR12 9SQ",
"region": "London",
"lat": 51.2944,
"lng": -0.0646,
"valuer": "Jack Kibblewhite",
"status": "Submitted",
"valuation": 249000,
"feeEx": 276.95,
"feeInc": 332.34,
"tier": "£200k–250k",
"instructed": "2025-10-08T02:25",
"submitted": "2025-10-10T11:25",
"rejectionReason": null,
"pvqResponseHours": 16.0
},
{
"ref": "F006807",
"type": "AVM",
"address": "111 Victoria Street, Croydon",
"postcode": "CR18 6ES",
"region": "London",
"lat": 51.3456,
"lng": -0.0603,
"valuer": null,
"status": "Submitted",
"valuation": 282000,
"feeEx": 29.0,
"feeInc": 34.8,
"tier": "AVM",
"instructed": "2025-10-06T03:47",
"submitted": "2025-10-07T12:47",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012965",
"type": "RICS",
"address": "127 Marlborough Road, Manchester",
"postcode": "M3 7RZ",
"region": "North West",
"lat": 53.5693,
"lng": -2.235,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 142000,
"feeEx": 218.1,
"feeInc": 261.72,
"tier": "£100k–150k",
"instructed": "2025-10-04T02:22",
"submitted": "2025-10-07T12:22",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012510",
"type": "RICS",
"address": "94 Cedar Close, Nottingham",
"postcode": "NG19 7QE",
"region": "East Midlands",
"lat": 52.9855,
"lng": -1.1648,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 99000,
"feeEx": 194.45,
"feeInc": 233.34,
"tier": "£50k–100k",
"instructed": "2025-10-03T21:04",
"submitted": "2025-10-06T04:04",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012393",
"type": "RICS",
"address": "86 Park Avenue, Swansea",
"postcode": "SA5 2NX",
"region": "Wales",
"lat": 51.5988,
"lng": -3.873,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 165000,
"feeEx": 230.75,
"feeInc": 276.9,
"tier": "£150k–200k",
"instructed": "2025-09-30T16:10",
"submitted": "2025-10-06T02:10",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012551",
"type": "RICS",
"address": "41 Cedar Close, Sunderland",
"postcode": "SR15 5HR",
"region": "North East",
"lat": 54.9696,
"lng": -1.4774,
"valuer": "Daniel Lightstone",
"status": "Submitted",
"valuation": 289000,
"feeEx": 298.95,
"feeInc": 358.74,
"tier": "£250k–300k",
"instructed": "2025-09-27T21:24",
"submitted": "2025-10-03T07:24",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012082",
"type": "RICS",
"address": "29 York Street, Croydon",
"postcode": "CR15 2HY",
"region": "London",
"lat": 51.37,
"lng": -0.0043,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 383000,
"feeEx": 350.65,
"feeInc": 420.78,
"tier": "£350k–400k",
"instructed": "2025-09-23T11:39",
"submitted": "2025-09-26T13:39",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012483",
"type": "RICS",
"address": "68 Kings Road, Luton",
"postcode": "LU25 6WY",
"region": "East of England",
"lat": 51.8076,
"lng": -0.4191,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 328000,
"feeEx": 320.4,
"feeInc": 384.48,
"tier": "£300k–350k",
"instructed": "2025-09-20T01:52",
"submitted": "2025-09-22T02:52",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012742",
"type": "RICS",
"address": "139 Mill Lane, Brighton",
"postcode": "BN25 1AJ",
"region": "South East",
"lat": 50.7729,
"lng": -0.2671,
"valuer": "Jack Kibblewhite",
"status": "Cancelled",
"valuation": 283000,
"feeEx": 295.65,
"feeInc": 354.78,
"tier": "£250k–300k",
"instructed": "2025-09-19T23:07",
"submitted": null,
"rejectionReason": "Cancelled at client request",
"pvqResponseHours": null
},
{
"ref": "R012046",
"type": "RICS",
"address": "127 Albion Terrace, Liverpool",
"postcode": "L14 3NR",
"region": "North West",
"lat": 53.3511,
"lng": -2.9819,
"valuer": "Amelia Fothergill",
"status": "Cancelled",
"valuation": 308000,
"feeEx": 309.4,
"feeInc": 371.28,
"tier": "£300k–350k",
"instructed": "2025-09-18T01:40",
"submitted": null,
"rejectionReason": "Insufficient digital information available",
"pvqResponseHours": null
},
{
"ref": "R012074",
"type": "RICS",
"address": "121 Victoria Street, Norwich",
"postcode": "NR28 7RD",
"region": "East of England",
"lat": 52.6629,
"lng": 1.3358,
"valuer": "Amelia Fothergill",
"status": "Submitted",
"valuation": 177000,
"feeEx": 237.35,
"feeInc": 284.82,
"tier": "£150k–200k",
"instructed": "2025-09-12T13:18",
"submitted": "2025-09-19T18:18",
"rejectionReason": null,
"pvqResponseHours": null
},
{
"ref": "R012633",
"type": "RICS",
"address": "65 Priory Lane, Birmingham",
"postcode": "B2 3UW",
"region": "West Midlands",
"lat": 52.5133,
"lng": -1.7901,
"valuer": "Marcus Adeyemi",
"status": "Submitted",
"valuation": 459000,
"feeEx": 392.45,
"feeInc": 470.94,
"tier": "£450k–500k",
"instructed": "2025-09-10T10:00",
"submitted": "2025-09-11T20:00",
"rejectionReason": null,
"pvqResponseHours": 21.7
}
];

// Simulated async fetch — replace body with a real API call later.
export function getReports() {
    return new Promise((resolve) => {
        setTimeout(() => resolve({ report_details: DATA }), 120);
    });
}

export default { getReports, REJECTION_REASONS, CLIENT };
